import { render, staticRenderFns } from "./CustomeArrow.vue?vue&type=template&id=31eb374a&scoped=true&"
import script from "./CustomeArrow.vue?vue&type=script&lang=js&"
export * from "./CustomeArrow.vue?vue&type=script&lang=js&"
import style0 from "./CustomeArrow.vue?vue&type=style&index=0&id=31eb374a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb374a",
  null
  
)

export default component.exports